import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Workflow, WorkflowCandidateList } from './types';

export type StatusPayload = {
  searchConditions: Record<string, unknown>[] | Record<string, unknown>;
  conditions: Record<string, unknown>;
  limit: number;
  offset: number;
  courseId: number;
  callback?: {
    onSuccess: (res: unknown) => void;
  };
};

export const initialState: {
  isLoading: boolean;
  isSuccess: boolean;
  error: string | Error | null;
  data: Workflow[];
  totalCount: number;
  workflowCandidateList: {
    isLoading: boolean;
    isSuccess: boolean;
    error: string | Error | null;
    data: WorkflowCandidateList[];
  };
} = {
  isLoading: false,
  isSuccess: false,
  error: null,
  data: [],
  totalCount: -1,
  workflowCandidateList: {
    isLoading: false,
    isSuccess: false,
    error: null,
    data: [],
  },
};

export const workFlowList = createSlice({
  name: 'workFlowList',
  initialState: initialState,
  reducers: {
    getWtfWorkflowAction: (state, _payload: PayloadAction<StatusPayload>) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.error = null;
    },

    getWtfWorkflowSuccessAction: (state, { payload }: PayloadAction<{ data: Workflow[]; count: number }>) => {
      state.data = payload.data;
      state.totalCount = payload.count;
      state.isSuccess = true;
      state.isLoading = false;
      state.error = null;
    },

    getWtfWorkflowErrorAction: (state, { payload: error }) => {
      state.error = error;
      state.isLoading = false;
      state.isSuccess = false;
    },

    getWorkflowCandidateListAction: (state, _action: PayloadAction<{ workflow_id: number; step_id: number }>) => {
      state.workflowCandidateList.isLoading = true;
      state.workflowCandidateList.isSuccess = false;
      state.workflowCandidateList.error = null;
    },

    getWorkflowCandidateListSuccessAction: (state, { payload }: PayloadAction<{ data: WorkflowCandidateList[] }>) => {
      state.workflowCandidateList.data = payload.data;
      state.workflowCandidateList.isSuccess = true;
      state.workflowCandidateList.isLoading = false;
      state.workflowCandidateList.error = null;
    },

    getWorkflowCandidateListErrorAction: (state, { payload: error }) => {
      state.workflowCandidateList.error = error;
      state.workflowCandidateList.isLoading = false;
      state.workflowCandidateList.isSuccess = false;
    },
  },
});

export const {
  getWtfWorkflowAction,
  getWtfWorkflowSuccessAction,
  getWtfWorkflowErrorAction,
  getWorkflowCandidateListAction,
  getWorkflowCandidateListSuccessAction,
  getWorkflowCandidateListErrorAction,
} = workFlowList.actions;

export default workFlowList.reducer;
